import styled from 'styled-components';

const Layout = styled.div<{height: number}>`
  height: ${({height})=>height}px;
  width: 100%;
`;
export default Layout;
